import React from 'react';
import styled from 'styled-components';
import { useDispatch, useSelector } from 'react-redux';
import { Colors } from 'planoplan-ui-kit/core/colors';
import { Mixins } from 'planoplan-ui-kit/core/mixins';
import { IClose } from 'planoplan-ui-kit/core/icons/i-close';
import { BANNERS } from '@constants';
import { Points } from '@styles';
import { setHideBanner } from '@store/actions';

export const CardBanner = () => {
  const { common = {}, showBanners = {} } = useSelector((state) => state);
  const { banner = {} } = common;
  const { link, description, cover, color } = banner;
  const dispatch = useDispatch();
  const isShow = showBanners[BANNERS.CARD] || false;

  const onClose = () => dispatch(setHideBanner(BANNERS.CARD));

  if (!isShow) {
    return null;
  }

  return (
    <Container>
      <Content href={link} target="_blank" cover={cover}>
        <Description color={color} dangerouslySetInnerHTML={{ __html: description }} />
      </Content>
      <Close onClick={onClose}>
        <IClose width="14px" height="14px" fill={color} />
      </Close>
    </Container>
  );
};

const Container = styled.div`
  position: sticky;
  top: 80px;
  width: 280px;
  height: 350px;
  display: none;

  @media ${Points.laptop} {
    display: block;
  }
`;

const Content = styled.a`
  ${Mixins.resetLink()};
  border-radius: 10px;
  background-color: ${Colors.electric_blue};
  width: 100%;
  height: 100%;
  padding-right: 40px;
  padding-left: 40px;
  background-image: ${(p) => (p.cover ? `url(${p.cover})` : 'none')};
  background-color: ${Colors.nobel};
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
  display: block;

  @media ${Points.laptop} {
    padding-top: 120px;
  }
`;

const Description = styled.div`
  color: ${({ color }) => color};

  p:first-child {
    font-weight: bold;
    font-size: 20px;
    line-height: 20px;
    margin-bottom: 10px;
  }

  p:last-child {
    font-weight: normal;
    font-size: 16px;
    line-height: 100%;
  }
`;

const Close = styled.button`
  ${Mixins.resetButton()};
  position: absolute;
  top: 15px;
  right: 15px;
  z-index: 1;
`;
